class MCartDrawer extends HTMLElement {
    constructor() {

        super(), this.cartDrawerInner = this.querySelector(".m-cart-drawer__bsf-inner"), this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close"), this.cartOverlay = this.querySelector(".m-cart__overlay"), this.rootUrl = window.Shopify.routes.root, this.setHeaderCartIconAccessibility(), this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
        // BSF: Use event delegation for continue shopping buttons (handles dynamic content updates)
        this.addEventListener("click", (e => {
            if (e.target.closest(".m-cart-drawer__continue-shopping, .cart-drawer-empty__button")) {
                this.close();
            }
        }));

        // BSF: Event CAPTURING for add-to-cart in cart drawer recommendations
        // Must use capture phase (true) to intercept BEFORE product-form's submit handler
        // Handles BOTH empty cart recommendations AND regular cart recommendations
        this.addEventListener("click", (e => {
            // Don't intercept clicks on the quantity select - let native picker open
            if (e.target.closest('.bsf-rec-qty-select')) {
                return;
            }

            // Check for forms in empty cart recommendations OR regular cart-recommendations
            const form = e.target.closest('.cart-drawer-empty__recommendations .product-card-form, cart-recommendations .product-card-form');
            if (form) {
                const addButton = form.querySelector('.m-add-to-cart');
                if (addButton) {
                    e.preventDefault();
                    e.stopImmediatePropagation(); // Stop ALL other handlers
                    this.handleEmptyCartAddToCart(form, addButton);
                }
            }
        }), true); // CAPTURE PHASE - runs before target handlers

        // BSF: Handle SUBMIT events from quantity select changes
        this.addEventListener("submit", (e => {
            const form = e.target.closest('.cart-drawer-empty__recommendations .product-card-form, cart-recommendations .product-card-form');
            if (form) {
                e.preventDefault();
                e.stopImmediatePropagation();
                const addButton = form.querySelector('.m-add-to-cart');
                if (addButton) {
                    this.handleEmptyCartAddToCart(form, addButton);
                }
            }
        }), true); // CAPTURE PHASE

        this.addEventListener("click", (e => {
            e.target.closest(".m-cart-drawer__bsf-inner") !== this.cartDrawerInner && this.close()
        }));

        // BSF: Initialize empty cart qty selects on page load
        this.initEmptyCartQtySelects();

        // BSF: Re-initialize qty selects when cart content changes (e.g., after removing an item)
        // This ensures the empty cart recommendations work again when cart becomes empty
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
            // Use timeout to ensure DOM has updated before re-initializing
            setTimeout(() => this.initEmptyCartQtySelects(), 100);
        });
    }

    setHeaderCartIconAccessibility() {
        document.querySelectorAll(".m-cart-icon-bubble").forEach((e => {
            e.setAttribute("role", "button"), e.setAttribute("aria-haspopup", "dialog"), e.addEventListener("click", (t => {
                MinimogSettings.enable_cart_drawer && (t.preventDefault(), this.open(e))
            }))
        }))
    }

    open(e) {
        e && this.setActiveElement(e);
        // BSF: Keep recommendations hidden initially for stagger effect
        const recommendations = this.querySelector('.cart--recommendations--desktop');
        if (recommendations) {
            recommendations.style.setProperty("--recommendations-translate-x", "210%");
        }
        this.classList.add("m-cart-drawer--active");
        requestAnimationFrame((() => {
            this.style.setProperty("--m-bg-opacity", "0.3");
            this.cartDrawerInner.style.setProperty("--translate-x", "0");
            const bodyOverlay = document.querySelector('.body-overlay');
            if (bodyOverlay) {
                bodyOverlay.style.setProperty("--m-bg-opacity", "0.3");
            }
            // BSF: Stagger recommendations - slide out after cart drawer starts
            setTimeout(() => {
                if (recommendations) {
                    recommendations.style.removeProperty("--recommendations-translate-x");
                }
            }, 150);
        }));
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
        document.documentElement.classList.add("prevent-scroll");
        // BSF: Ensure qty select listeners are initialized (desktop empty cart recs)
        setTimeout(() => this.initEmptyCartQtySelects(), 100);
    }

    close() {
        this.style.setProperty("--m-bg-opacity", "0");
        this.cartDrawerInner.style.setProperty("--translate-x", "100%");
        // BSF: Animate recommendations out with drawer
        const recommendations = this.querySelector('.cart--recommendations--desktop');
        if (recommendations) {
            recommendations.style.setProperty("--recommendations-translate-x", "210%");
        }
        const bodyOverlay = document.querySelector('.body-overlay');
        if (bodyOverlay) {
            bodyOverlay.style.setProperty("--m-bg-opacity", "0");
        }
        setTimeout((() => {
            this.classList.remove("m-cart-drawer--active");
            document.documentElement.classList.remove("prevent-scroll");
            // BSF: Reset for next open
            if (recommendations) {
                recommendations.style.removeProperty("--recommendations-translate-x");
            }
        }), 500)  // BSF: Match CSS duration (0.50s)
    }

    renderContents(e, fromRecommendation = false) {
        // Remove empty state class
        this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
        this.productId = e.id;

        // Validate sections exist
        if (!e.sections) {
            console.error('No sections in response');
            return;
        }

        // BSF: Capture scroll position
        const scrollContainer = this.querySelector('.m-cart-drawer__body');
        const scrollTop = scrollContainer?.scrollTop || 0;

        // BSF: Capture old subtotal for price animation
        const subtotalEl = document.querySelector('[data-cart-subtotal-price]');
        const oldSubtotal = subtotalEl?.textContent || '';

        this.getSectionsToRender().forEach((t => {
            const targetEl = t.selector ? document.querySelector(t.selector) : document.getElementById(t.id);
            const sectionHTML = e.sections[t.id];

            if (!targetEl) {
                console.error('Target element not found:', t.selector || t.id);
                return;
            }
            if (!sectionHTML) {
                console.error('Section HTML not found for:', t.id);
                return;
            }

            try {
                // BSF: Instant update (no fade - cleaner feel)
                targetEl.innerHTML = this.getSectionInnerHTML(sectionHTML, t.selector);

                // BSF: Restore scroll position
                if (scrollContainer) scrollContainer.scrollTop = scrollTop;

                // BSF: Stagger entry animations for cart items
                if (t.block === 'cart-items') {
                    const items = targetEl.querySelectorAll('.m-cart-drawer-item');
                    items.forEach((item, i) => {
                        item.style.animationDelay = `${i * 50}ms`;
                        item.classList.add('m-cart-drawer-item--entering', 'bsf-animating');
                        item.addEventListener('animationend', () => {
                            item.classList.remove('m-cart-drawer-item--entering', 'bsf-animating');
                            item.style.animationDelay = '';
                        }, { once: true });
                    });
                }
            } catch (err) {
                console.error('Error updating section:', t.id, err);
            }
        }));

        // BSF: Animate price change after DOM update
        setTimeout(() => {
            const newSubtotalEl = document.querySelector('[data-cart-subtotal-price]');
            if (newSubtotalEl && window.BsfPriceAnimator && oldSubtotal) {
                window.BsfPriceAnimator.animate(newSubtotalEl, oldSubtotal, newSubtotalEl.textContent);
            }
        }, 160);

        if (!fromRecommendation) {
            setTimeout((() => {
                this.open()
            }));
        }

        // BSF: Always reload recommendations to update desktop (which is outside replaced sections)
        // and ensure products in cart are filtered out
        setTimeout(() => {
            if (window.CartRecommendations) {
                // cart/add.js returns single item with product_id, cart.json returns items array
                const productId = e.items?.[0]?.product_id || e.product_id;
                if (productId) {
                    window.CartRecommendations.reloadAll(productId);
                }
            }
        }, 100);
    }

    updateCartCount(e) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((t => {
            e > 0 ? (t.textContent = e, t.classList.remove("m:hidden")) : t.classList.add("m:hidden")
        }))
    }

    getCart() {
        return fetchJSON(this.rootUrl + "cart.json")
    }

    onCartDrawerUpdate(e = !0) {
        fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`).then((e => e.text())).then((t => {
            this.getSectionsToRender().forEach((r => {
                if ("cart-items" === r.block) {
                    (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(t, r.selector)
                } else if (e) {
                    (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(t, r.selector)
                }
            }));
            // BSF: Initialize quantity selects for empty cart recommendations
            this.initEmptyCartQtySelects();
        })).catch((e => {
        })), this.getCart().then((e => {
            this.classList.toggle("m-cart--empty", 0 === e.item_count), this.updateCartCount(e.item_count)
        }))
    }

    // BSF: Handle add-to-cart from empty cart recommendations
    handleEmptyCartAddToCart(form, button) {
        const variantInput = form.querySelector('input[name="id"]');
        const qtySelect = form.querySelector('[data-bsf-qty-select]');
        const productCard = form.closest('.m-product-card--recommendation, .m-product-card');
        const productName = productCard?.querySelector('.m-product-card__name')?.textContent?.trim();

        if (!variantInput) {
            console.error('BSF: No variant input found in form');
            return;
        }

        const variantId = variantInput.value;
        const quantity = qtySelect && qtySelect.value ? parseInt(qtySelect.value) : 1;


        // BSF: Validate variant ID before request
        if (!variantId || variantId === 'undefined' || variantId === '') {
            console.error('BSF: Invalid variant ID:', variantId);
            return;
        }

        // BSF: Show loading state with optimistic feedback
        window.BsfCartToast?.adding();
        button.classList.add('m-spinner-button--loading');
        button.disabled = true;
        if (productCard) {
            productCard.style.opacity = '0.7';
            productCard.style.transition = 'opacity 200ms ease';
        }

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', quantity);
        formData.append('sections', this.getSectionsToRender().map(s => s.id).join(','));
        formData.append('sections_url', window.location.pathname);

        // BSF: Ensure URL ends with .js for JSON response (not HTML)
        let cartAddUrl = window.MinimogSettings?.routes?.cart_add_url || '/cart/add.js';
        if (!cartAddUrl.endsWith('.js')) {
            cartAddUrl = cartAddUrl + '.js';
        }

        fetch(cartAddUrl, {
            method: 'POST',
            body: formData
        })
        .then(response => {
            // BSF: Check content type - Shopify returns text/javascript for .js endpoints
            const contentType = response.headers.get('content-type') || '';
            const isJsonResponse = contentType.includes('application/json') || contentType.includes('text/javascript');
            if (!isJsonResponse) {
                return response.text().then(text => {
                    console.error('BSF: Unexpected content-type:', contentType);
                    console.error('BSF: Response body:', text.substring(0, 500));
                    throw new Error('Add to cart returned unexpected response');
                });
            }
            if (!response.ok) {
                throw new Error('Add to cart failed: ' + response.status);
            }
            return response.json();
        })
        .then(data => {
            // BSF: Check for Shopify API error (status is a number like 422)
            if (typeof data.status === 'number' && data.status >= 400) {
                console.error('Add to cart error:', data.description);
                window.BsfCartToast?.hide();
                if (productCard) productCard.style.opacity = '1';
                return;
            }

            // Validate sections data exists
            if (!data.sections || !data.sections['cart-drawer']) {
                console.error('Missing sections data in response, falling back to full refresh');
                this.onCartDrawerUpdate();
                this.classList.remove("m-cart--empty");
                this.getCart().then(cart => this.updateCartCount(cart.item_count));
                window.BsfCartToast?.added(productName);
                if (productCard) productCard.style.opacity = '1';
                return;
            }

            // BSF: Show success toast
            window.BsfCartToast?.added(productName);

            // BSF: Instant optimistic removal - hide the recommendation card immediately
            if (productCard) {
                const listItem = productCard.closest('li');
                if (listItem) {
                    listItem.style.transition = 'opacity 150ms ease, transform 150ms ease';
                    listItem.style.opacity = '0';
                    listItem.style.transform = 'scale(0.95)';
                    setTimeout(() => listItem.remove(), 150);
                } else {
                    productCard.style.opacity = '1';
                }
            }

            // BSF: Track if we're transitioning from empty to non-empty
            const wasEmpty = this.classList.contains('m-cart--empty');

            // Success - update cart drawer with animations
            this.renderContents(data, true);

            // BSF: Scroll to top so customer can see newly added product (delay for DOM update)
            setTimeout(() => {
                const scrollContainer = this.querySelector('.m-cart-drawer__body');
                if (scrollContainer) {
                    scrollContainer.scrollTop = 0;
                }
            }, 100);

            // BSF: Add smooth entry animation when going from empty to non-empty
            if (wasEmpty) {
                const body = this.querySelector('.m-cart-drawer__body');
                if (body) {
                    body.classList.add('m-cart-drawer__body--from-empty');
                    body.addEventListener('animationend', () => {
                        body.classList.remove('m-cart-drawer__body--from-empty');
                    }, { once: true });
                }
            }

            // Update cart count bubble
            if (data.item_count !== undefined) {
                this.updateCartCount(data.item_count);
            } else {
                this.getCart().then(cart => this.updateCartCount(cart.item_count));
            }

            // Emit cart update event for other components (with source to prevent duplicate recommendation reloads)
            window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
                ...data,
                source: "cart-drawer-recommendation"
            });
            // Note: recommendations reload is now handled by renderContents
        })
        .catch(error => {
            console.error('Add to cart error:', error);
            window.BsfCartToast?.hide();
            if (productCard) productCard.style.opacity = '1';
            this.onCartDrawerUpdate();
        })
        .finally(() => {
            button.classList.remove('m-spinner-button--loading');
            button.disabled = false;
        });
    }

    // BSF: Initialize quantity selects in cart recommendations (mobile empty + desktop empty)
    initEmptyCartQtySelects() {
        // BSF: Init qty selects in mobile empty cart recommendations
        const emptyContent = this.querySelector('.cart-drawer-empty__recommendations');
        if (emptyContent) {
            this._initQtySelectsIn(emptyContent);
        }

        // BSF: Init qty selects in desktop recommendations (inside cart-recommendations element)
        // Needed because loadRecommendations() may fail with empty product_id,
        // leaving the Liquid-rendered fallback products without change listeners
        this.querySelectorAll('cart-recommendations').forEach((el) => {
            this._initQtySelectsIn(el);
        });
    }

    // BSF: Helper to init qty select change listeners within a container
    _initQtySelectsIn(container) {
        container.querySelectorAll('[data-bsf-qty-select]').forEach((select) => {
            if (select.dataset.initialized) return;
            select.dataset.initialized = 'true';

            const form = select.closest('form');
            if (!form) return;

            select.addEventListener('change', () => {
                if (select.value) {
                    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
            });
        });

        // BSF: Also ensure product-form elements are initialized
        container.querySelectorAll('product-form').forEach((productForm) => {
            if (productForm.dataset.initialized) return;
            productForm.dataset.initialized = 'true';

            if (typeof productForm.init === 'function') {
                productForm.init();
            }
        });
    }

    getSectionInnerHTML(e, t = ".shopify-section") {
        return (new DOMParser).parseFromString(e, "text/html").querySelector(t).innerHTML
    }

    getSectionsToRender() {
        return [{id: "cart-drawer", selector: "[data-minimog-cart-items]", block: "cart-items"}, {
            id: "cart-drawer",
            selector: "[data-minimog-cart-discounts]",
            block: "cart-footer"
        }, {id: "cart-drawer", selector: "[data-cart-subtotal]", block: "cart-footer"}, {
            id: "cart-drawer",
            selector: "[data-minimog-gift-wrapping]",
            block: "cart-footer"
        }]
    }

    getSectionDOM(e, t = ".shopify-section") {
        return (new DOMParser).parseFromString(e, "text/html").querySelector(t)
    }

    setActiveElement(e) {
        this.activeElement = e
    }

}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
    getSectionsToRender() {
        return [{
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-items]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-discounts]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-cart-subtotal]"
        }, {id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-gift-wrapping]"}]
    }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);